
/**
 * 강의 콘텐츠 유형
 */
export type CourseCurriculumLocalizationSectionsItemLecturesItemContentType = typeof CourseCurriculumLocalizationSectionsItemLecturesItemContentType[keyof typeof CourseCurriculumLocalizationSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseCurriculumLocalizationSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
  ASSIGNMENT: 'ASSIGNMENT',
  LIVE: 'LIVE',
  DISCUSSION: 'DISCUSSION',
  ARTICLE: 'ARTICLE',
  UNKNOWN: 'UNKNOWN',
} as const;
